// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1yPyN","inputDescription":"styles_inputDescription__3f3dY"};